import { render, staticRenderFns } from "./KusBaseLayoutSlider.vue?vue&type=template&id=11089a33"
import script from "./KusBaseLayoutSlider.vue?vue&type=script&lang=js"
export * from "./KusBaseLayoutSlider.vue?vue&type=script&lang=js"
import style0 from "./KusBaseLayoutSlider.vue?vue&type=style&index=0&id=11089a33&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports